import { lazy, useMemo, useState, Suspense } from "react";
import { pascalCase } from "change-case";

import FormFieldLoader from "@components/form/FormFieldLoader";

const loadFieldComponent = (type) => {
  return lazy(() => {
    return import(`./../field_types/${pascalCase(type)}.js`).catch((error) => {
      console.error(error);
      return import("./../field_types/TextField");
    });
  });
};

const defaultConfig = {
  isDisabled: false,
  trackChanges: true,
};

export default function FormField(props) {
  const {
    type,
    name,
    value,
    initialValue,
    error,
    change,
    onChange,
    config,
    resource,
    path,
  } = props;

  const isDisabled = config.isDisabled ?? defaultConfig.isDisabled;
  const trackChanges = config.trackChanges ?? defaultConfig.trackChanges;

  /**************************************************************************************************/

  const FieldComponent = useMemo(() => loadFieldComponent(type), [type]);

  const [isValueChanged, setIsValueChanged] = useState(false);

  const isChanged = useMemo(() => {
    return !isDisabled && trackChanges && isValueChanged;
  }, [isDisabled, trackChanges, isValueChanged]);

  return (
    <Suspense fallback={<FormFieldLoader />}>
      <FieldComponent
        name={name}
        value={value}
        initialValue={initialValue}
        error={error}
        change={change}
        onChange={onChange}
        config={config}
        resource={resource}
        path={path}

        isDisabled={isDisabled}
        isChanged={isChanged}

        setIsValueChanged={setIsValueChanged}
      />
    </Suspense>
  );
}
